import { useDialog } from "@shared/features/dialog/useDialog";
import { useMobileMenu } from "@shared/features/mobileMenu/useMobileMenu";
import { useUserCircle } from "@platform/hooks/useUserCircle";
import { ProgramCircleParticipantsDialog } from "./ProgramCircleParticipantsDialog";

export function ProgramCircleParticipantsContainer() {
  const { activeDialog, closeDialog } = useDialog();

  const { closeMobileMenu } = useMobileMenu();

  const isOpen = activeDialog === "circle";

  const circle = useUserCircle();

  const handleDone = async () => {
    // close the dialog
    closeDialog("circle");

    closeMobileMenu();
  };

  return (
    <ProgramCircleParticipantsDialog
      participants={circle?.users}
      onClose={handleDone}
      isOpen={isOpen}
    />
  );
}

export default ProgramCircleParticipantsContainer;
